import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { UserType } from '@/app/api/users';
import { AccessService } from '@/app/shared/services/access';
import { NamedRouter } from '@/app/core/services/named-router';

export const userTypeGuard = (availableUserTypes: UserType[]): CanMatchFn => {
  return () => {
    const namedRoute = inject(NamedRouter);
    const accessService = inject(AccessService);

    if (accessService.hasAnyTypes(availableUserTypes)) {
      return true;
    }

    namedRoute.navigate(['/']);
    return false;
  };
};
